import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { Subtitle, Title } from '@/shared/auth/components/common/card'
import { AuthErrorComponent } from '@/shared/auth/components/common/error-component'
import { AuthPendingComponent } from '@/shared/auth/components/common/pending-component'

import { Skeleton } from '@/components/ui/skeleton'

const SetupTOTPForm = lazy(
	() => import('@/shared/auth/components/forms/setup-totp'),
)

export const Route = createFileRoute('/_auth/setup-totp')({
	component: SetupTotpRoute,
	pendingComponent: AuthPendingComponent,
	errorComponent: AuthErrorComponent,
})

function SetupTotpRoute() {
	return (
		<>
			<title>Setup Time-Based One-Time Password | BitLyft AIR®</title>

			<Title>Setup Two-Factor Authentication</Title>
			<Subtitle className="text-center">
				Scan QR code with authenticator app to receive one time code for this
				platform
			</Subtitle>

			<Suspense fallback={<Skeleton className="my-4 h-72 w-full" />}>
				<SetupTOTPForm />
			</Suspense>
		</>
	)
}
